import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../inc/Footer";
import axios from "axios";
import HomeCards from "../inc/HomeCards";
import "../inc/GlobalVars";
const Homepage = () => {

  const userId = localStorage.getItem("userId");
  const [east, setEast] = useState('');
  const [north, setNorth] = useState('');
  const [south, setSouth] = useState('');
  const [west, setWest] = useState('');


  const [commercial, setCommercial] = useState('');
  const [theft, setTheft] = useState('');
  const [flood,setFlood] = useState('');
  const [luxury, setLuxury] = useState('');

  const [readyToLift, setReadyToLift] = useState('');
  const [partial, setPartial] = useState('');
  const [fire, setFire] = useState('');
  const [transit, setTransit] = useState('');

  const [pan, setPan] = useState('');
  const allData = async () => {
    try {
      // Call both APIs in parallel using Promise.all
      const [eastResponse, northResponse, soutResponse, westResponse, commercialResponse, theftResponse, floodResponse, readyToLiftResponse, partialResponse, fireResponse, transitResponse, panResponse, luxuryResponse ] = await Promise.all([
        axios.get(global.apiUrl+'/countZoneAuctionList/east'),
        axios.get(global.apiUrl+'/countZoneAuctionList/north'),
        axios.get(global.apiUrl+'/countZoneAuctionList/south'),
        axios.get(global.apiUrl+'/countZoneAuctionList/west'),

        axios.get(global.apiUrl+'/countCaseAuctionList/6'),
        axios.get(global.apiUrl+'/countCaseAuctionList/3'),
        axios.get(global.apiUrl+'/countCaseAuctionList/5'),
        axios.get(global.apiUrl+'/countCaseAuctionList/9'),
        axios.get(global.apiUrl+'/countCaseAuctionList/8'),
        axios.get(global.apiUrl+'/countCaseAuctionList/7'),
        axios.get(global.apiUrl+'/countCaseAuctionList/4'),
        axios.get(global.apiUrl+'/countAllAuctionList'),
        axios.get(global.apiUrl+'/countCaseAuctionList/2'),
        
      ]);

      // Extract the "data" value from the responses and update state
      setEast(eastResponse.data.data);
      setNorth(northResponse.data.data);
      setSouth(soutResponse.data.data);
      setWest(westResponse.data.data);
      setCommercial(commercialResponse.data.data);
      setTheft(theftResponse.data.data);
      setFlood(floodResponse.data.data);
      setReadyToLift(readyToLiftResponse.data.data);
      setPartial(partialResponse.data.data);
      setFire(fireResponse.data.data);
      setTransit(transitResponse.data.data);
      setPan(panResponse.data.data);
      setLuxury(luxuryResponse.data.data);


    } catch (error) {
      //console.error('Error fetching data:', error);
    }
  }
  
  useEffect(() => {
    allData();
  }, []);
  return (
    <div>

<div >
<div id="carouselExampleSlidesOnly" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img src={window.location.origin + '/images/baneer_new10.jpg'} className="d-block w-100" alt="" />
    </div>
    <div className="carousel-item">
      <img src={window.location.origin + '/images/banner_new9.jpg'} className="d-block w-100" alt="" />
    </div>
   
  </div>
</div>
</div>
    
    <div className="container mt-2">
      <div className="row mb-5">
        <div className="col-12 text-center">
          <h2 className="cat-head">Insurance Auction Vehicles</h2>
          <hr/>
        </div>
      </div>

      <div className="row">
          
          <HomeCards vehicleCount={north} url="/Region/north" imageSrc='/images/homeimages/north.png' zone='North' userId= {userId} />
          <HomeCards vehicleCount={east} url="/Region/east" imageSrc='/images/homeimages/east.png' zone='East' userId= {userId} />
          <HomeCards vehicleCount={south} url="/Region/south" imageSrc='/images/homeimages/south.png' zone='South' userId= {userId} />
          <HomeCards vehicleCount={west} url="/Region/west" imageSrc='/images/homeimages/west.png' zone='West' userId= {userId} />

          <HomeCards vehicleCount={commercial} url="/Cases/6" imageSrc='/images/homeimages/commercial.png' zone='Commercial' userId= {userId} />
          <HomeCards vehicleCount={theft} url="/Cases/3" imageSrc='/images/homeimages/theft.png' zone='Theft' userId= {userId} />
          <HomeCards vehicleCount={flood} url="/Cases/5" imageSrc='/images/homeimages/flood.png' zone='Flood' userId= {userId} />
          <HomeCards vehicleCount={luxury} url="/Cases/2" imageSrc='/images/homeimages/luxury.png' zone='Luxury' userId= {userId} />

          <HomeCards vehicleCount={readyToLift} url="/Cases/9" imageSrc='/images/homeimages/readytolift.png' zone='Ready To Lift' userId= {userId} />

          <HomeCards vehicleCount={partial} url="/Cases/8" imageSrc='/images/homeimages/partial.png' zone='Partial Salvage' userId= {userId} />
          <HomeCards vehicleCount={fire} url="/Cases/7" imageSrc='/images/homeimages/fireloss.png' zone='Fire Loss' userId= {userId} />
          <HomeCards vehicleCount={transit} url="/Cases/4" imageSrc='/images/homeimages/transit.png' zone='Transit' userId= {userId} />

          <HomeCards vehicleCount={pan} url="/Auctions" imageSrc='/images/homeimages/pan.png' zone='Pan India' userId= {userId} />

      </div>
    </div>
   
    
        

        <div className='container mt-5'>
            <div className='row'>
                

                <div className='col-md-6'>
                  <h2 style={{fontSize:"5rem"}}>Welcome to Indus Spare Bazaar</h2>
                    <p>
                    We are an Organization, serving online-auction amenities to our clients (Public & private motor-insurance companies) with an eminence and trustworthy consumer base. Been in the domain for half a decade, we have mastered the skill offline and now have arrived into the online space with an aim to showcase supreme and delightful facilities by leveraging technological and digital resources.
                    </p>
                    <Link to="/About" class="btn btn-primary default-button">Read More</Link>
                </div>
                <div className="col-md-6">
                    <img src={window.location.origin + '/images/aboutus.png'} className="img-fluid" alt="" />
                </div>
            </div>
           


        </div>
        <Footer/>
   </div>
   
  );
};

export default Homepage;
